<div class="breadcrumbs">
  <ul class='{{classList}}'>

    <li *ngFor="let el of elements">
      <a *ngIf="el.routerLink !== ''" [routerLink]="[el.routerLink]" [queryParams]='el?.queryParams' [attr.aria-label]="'breadcrumbs - ' + el.displayValue">{{ el.displayValue }}</a>
      <a *ngIf="el.routerLink === ''">{{ el.displayValue }}</a>
    </li>
    <li *ngIf="dropDownElements?.length >0" class='pt-4'>
        <mat-form-field appearance="fill" class='custom-select-like-dropdown ubuntu fit-content pv-sm-field ' style="height: 40px;position:relative;top: -18px!important"  subscriptSizing="dynamic">
          <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
          <mat-select [value]="selectedValue"  (selectionChange)="emitDropDownValue($event)" disableOptionCentering tabindex="0" >
            <mat-option [attr.aria-label]="'breadcrumbs - ' + element.value" [value]="element.value" *ngFor="let element of dropDownElements"><img class=" me-2" [src]="element?.icon" width="25" height="25" *ngIf="element?.icon" [matTooltip]="element?.tooltip|translate" >{{element.value}}  {{ element.displayValue?  '-'+ element.displayValue:null }} </mat-option>
          </mat-select>
        </mat-form-field>
    </li>
  </ul>
</div>
